import { combineReducers } from 'redux';
import channelChannelFeedView from './channelChannelFeedView';
import chId from './chId';
export default combineReducers({
  channelChannelFeedView,
  chId,
});
